import {
  ChangeEvent, FC, useEffect, useRef, useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'

import style from '@src/pages/Registration/Registration.module.scss'
import { Modal } from '@src/components/Modal/Modal'
import { selectAuthConfirmPhone, selectIsLoading } from '@src/store/ducks/auth/selectors'
import { ReactComponent as Spinner } from '@src/assets/spinner.svg'
import { AppDispatch } from '@src/store/store'
import { recoveryPasswordFirstStep } from '@src/store/ducks/auth/thunks'

type SmsModalProps = {
  isConfirmAction: boolean
  closeModal?: any
  callback: (code: string) => void
  backError?: string | object | null
}

const SECONDS = 61

export const SmsModal: FC<SmsModalProps> = ({
  isConfirmAction,
  closeModal,
  callback,
  backError,
}) => {
  const dispatch = useDispatch<AppDispatch>()
  const isLoading = useSelector(selectIsLoading)
  const confirmPhone = useSelector(selectAuthConfirmPhone)
  // const successChangePhone = useSelector(selectIsLoading)

  const [codes, setCodes] = useState(['', '', '', ''])
  const [seconds, setSeconds] = useState(SECONDS)
  const [timerActive, setTimerActive] = useState(false)

  useEffect(() => () => { setCodes(['', '', '', '']) }, [])

  // фокус на следующий инпут при вводе
  const handleChangeInput = async (e: ChangeEvent<HTMLInputElement>) => {
    const id = Number(e.target.getAttribute('name')) - 1
    const { value } = e.target
    await setCodes((prev) => {
      const newArr = [...prev]
      newArr[id] = value
      return newArr
    })

    if (e.target.nextSibling) {
      (e.target.nextSibling as HTMLInputElement).focus()
    }
  }
  // отправка запроса при вводе последней цифры
  useEffect(() => {
    if (codes.every((v) => !!v)) {
      callback(codes.join(''))
      setCodes(['', '', '', ''])
    }
  }, [callback, codes])

  useEffect(() => {
    if (isConfirmAction) {
      setTimerActive(true)
      setSeconds(SECONDS)
    }
  }, [isConfirmAction])

  useEffect(() => {
    if (seconds > 0 && timerActive) {
      setTimeout(setSeconds, 1000, seconds - 1)
    } else {
      setTimerActive(false)
      setSeconds(SECONDS)
    }
  }, [seconds, timerActive])

  const sendCode = () => {
    setTimerActive(!timerActive)
    if (confirmPhone) {
      dispatch(recoveryPasswordFirstStep(confirmPhone))
    }
  }

  // автофокус при открытии модального окна

  const inputEl = useRef<any>(null)

  useEffect(() => {
    if (isConfirmAction) inputEl?.current?.focus()
  }, [isConfirmAction])
  return (
    <Modal isOpen={isConfirmAction} close={closeModal}>
      <div className={style.confirmActions}>
        <div className={style.title}>
          Введите код из СМС
        </div>
        <div className={style.inputBody}>
          <input
            type="tel"
            name="1"
            maxLength={1}
            pattern="\d*"
            className={style.smsInput}
            onChange={handleChangeInput}
            value={codes[0]}
            autoFocus
            ref={inputEl}
          />
          <input
            type="tel"
            name="2"
            maxLength={1}
            className={style.smsInput}
            onChange={handleChangeInput}
            value={codes[1]}
            disabled={!codes[0]}
          />
          <input
            type="tel"
            name="3"
            maxLength={1}
            className={style.smsInput}
            onChange={handleChangeInput}
            value={codes[2]}
            disabled={!codes[1]}
          />
          <input
            type="tel"
            name="4"
            maxLength={1}
            className={style.smsInput}
            onChange={handleChangeInput}
            value={codes[3]}
            disabled={!codes[2]}
          />
        </div>
        <div className={style.sendBlock}>
          {backError && String(backError) && (
            <div className={style.error}>
              *
              {backError}
            </div>
          )}
          <div className={style.btnBlock}>
            <button
              type="button"
              disabled={timerActive || isLoading}
              onClick={() => sendCode()}
              className={style.sendAgain}
            >
              Отправить код повторно
            </button>
            {timerActive && (
              <div className={style.waitTime}>
                Повторная отправка через
                {' '}
                {seconds}
              </div>
            )}
            {isLoading && <Spinner className={style.spinner} />}
          </div>
        </div>
      </div>
    </Modal>
  )
}
